export const environment = {
  production: true,
  apiUrl: "https://cigaro-api.de/api"
  //apiUrl: "https://cigaro.net/api"
};
